import React, {Component} from 'react';
import {Link} from "react-router-dom";
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'
class ProductSpecificationsTopics extends React.Component {
    constructor(props){
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage =(elementId)=>{
        FocusPageId.selectedId={elementId}
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {

        return (
            <div className="static-pages">
                <div className="background-div">
                    <h3><b>
                        製品仕様について
                    </b></h3>
                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("a1")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> KITCUT PCB 注文番号とは
                            </b>
                            </h4>

                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("a")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 基板製造サービス仕様以外の基板製造はお願いできますか？</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("b")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 基板の最大製造寸法は？</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("c")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 外形加工、Vカット寸法公差は？</b>
                            </h4>

                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("d")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> レジスト印刷の色は指定できますか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("e")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> シルク印刷の色は指定できますか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("f")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 最小パターン幅を教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("g")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 最小パターン間隔を教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("h")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 最小ビア径を教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("i")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 最小ランド径を教えてください。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("j")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 最小パターン間隔を教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("k")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 最小、最大のドリル穴径を教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("l")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> ガーバーデータの出力形式の指定はありますか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("m")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> ガーバーデータは等倍で出力するのですか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("n")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color">ガーバーデータ・ドリルデータの単位、出力桁数について教えてください。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("o")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color">最小シルク文字幅について教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("p")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color">最小シルク文字高について教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("q")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 外形から銅箔までの推奨距離を教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("r")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color">Vカットセンターから銅箔部（パターン、ベタ）までの推奨距離を教えてください。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("s")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color">外形線幅について教えてください。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("t")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> Vカット線幅について教えてください。</b>
                            </h4>
                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("u")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color">ルーター外形について教えてください。</b>
                            </h4>

                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("v")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color">捨て基板について教えてください。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("w")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 外形データ描画について教えてください。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("x")}>
                        <Link to='/productspecifications'>
                            {/*<h4><b>端面スルーホールについて教えてください。</b>*/}
                            <h4><b className="reduce-font-size cart-row-text-color"> 端面スルーホールについて教えてください。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("y")}>
                        <Link to='/productspecifications'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 穴埋め（POH）基板について？</b>
                            </h4>
                        </Link>

                    </div>

                    {/*<div className='col-md-10'></div>*/}
                    <div className='faq-link-float-right   col-12-custom'>
                        <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                        </Link>
                    </div>

                </div>
            </div>

        );
    }
}

export default ProductSpecificationsTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/ProductSpecificationsTopics.js